import React, { useState } from "react"
import Typography from "aldoo-ra/Typography"
import ImagePreview from "aldoo-ra/CMS/preview/image-preview"
import VideoPreview from "aldoo-ra/CMS/preview/video-preview"
import VideoThumbnail from "aldoo-ra/CMS/preview/video-thumbnail"
import { url, filename } from "aldoo-ra/CMS/url"

const imageTypes = [".png", ".jpg", ".jpeg", ".gif", ".webp", ".svg"]
const videoTypes = [".mp4", ".webm", ".mov", ".avi"]

const PathCell = ({ path }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false)

  const isImage =
    path && imageTypes.some((ext) => path.toLowerCase().endsWith(ext))
  const isVideo =
    path && videoTypes.some((ext) => path.toLowerCase().endsWith(ext))
  const hasPreview = isImage || isVideo

  return (
    <div className="flex items-center gap-2">
      {isImage && (
        <>
          <img
            src={url(path)}
            className="w-10 h-10 object-cover rounded"
            alt="Preview"
          />
          <ImagePreview
            isOpen={isPreviewOpen && isImage}
            imageUrl={url(path)}
            fileName={filename(path)}
            onClose={() => setIsPreviewOpen(false)}
          />
        </>
      )}

      {isVideo && (
        <>
          <VideoThumbnail
            videoUrl={url(path)}
            width={40}
            height={40}
            onClick={() => setIsPreviewOpen(true)}
            className="flex-shrink-0"
          />
          <VideoPreview
            isOpen={isPreviewOpen && isVideo}
            videoUrl={url(path)}
            fileName={filename(path)}
            onClose={() => setIsPreviewOpen(false)}
          />
        </>
      )}

      <Typography
        className={`text-admin_text ${
          hasPreview ? "cursor-pointer hover:text-admin_primary" : ""
        }`}
        onClick={() => {
          hasPreview && setIsPreviewOpen(true)
        }}
      >
        {path || "No path"}
      </Typography>
    </div>
  )
}

export default PathCell
